import React from "react";
import { useLocalization } from "../../../context/LocalizationContext";
import "./LanguageToggle.css";

const LanguageToggle = () => {
  const { language, toggleLanguage, t } = useLocalization();

  return (
    <div className="language-toggle">
      <button
        className={`lang-btn ${language === "en" ? "active" : ""}`}
        onClick={() => language !== "en" && toggleLanguage()}
        aria-label={t("language.english")}
      >
        English
      </button>
      <button
        className={`lang-btn ${language === "ar" ? "active" : ""}`}
        onClick={() => language !== "ar" && toggleLanguage()}
        aria-label={t("language.arabic")}
      >
        العربية
      </button>
    </div>
  );
};

export default LanguageToggle;
